export function teacherGradePath(teacherId: string, gradeSlug: string): string {
  return `/teacher/${teacherId}/grade/${String(gradeSlug || 'secondary1').toLowerCase()}`;
}
